module.exports = __webpack_public_path__ + "static/media/manmonkey.1882423b.png";